var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37182_282141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55117 1.30562C9.74446 1.09084 10.0579 1.09084 10.2513 1.30562L18.6262 10.6111C18.8195 10.8259 18.8195 11.1741 18.6262 11.389L10.2513 20.6944C10.058 20.9092 9.74455 20.9093 9.55117 20.6944L1.17623 11.389C0.982924 11.1742 0.982924 10.826 1.17623 10.6111L9.55117 1.30562Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 7.33203V10.9987",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 14.6759L9.90367 14.668",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37182_282141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityOrder);
export default __webpack_public_path__ + "static/media/priorityOrder.1d2b033cde2b9dd1170c8dabbac0ac65.svg";
export { ForwardRef as ReactComponent };